"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsPayoutsKeyValsListCtl = /** @class */ (function (_super) {
    __extends(BrandsPayoutsKeyValsListCtl, _super);
    function BrandsPayoutsKeyValsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key_val = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key_val; });
        _this.dk_val_val = UIUtils_1.UIUtils.IProp2Str(function (o) { o.val_val; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsPayoutsKeyValsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandsPayoutsKeyValsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsPayoutsKeyValsListCtl.prototype.LoadData = function (brandAppPayoutId, onDone) {
        var _this = this;
        webAApi_1.ListBrandAppPayoutKeyValsGet.exec({ brand_app_payout_id: brandAppPayoutId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    key_val: resp.list[i].key,
                    val_val: resp.list[i].value,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayoutsKeyValsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandAppPayoutKeyVal.exec({
            data: {
                brand_app_payout_id: data.brand_app_payout_id,
                key: data.key_val,
                value: data.val_val,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                key_val: data.key_val,
                val_val: data.val_val,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    /*public EditData(data: IEditAppCountryItem, onDone?: () => void) {
        let _tmp = this.getById(data.key);
        if (_tmp) {
            DoEditBrandAppCountry.exec({
                data: {
                    brands_app_country_id: data.key,
                    app_country_id: data.app_country_id,
                }
            }, (resp: DoEditBrandAppCountryResponse) => {

                _tmp.app_country_id = data.app_country_id;
                _tmp.app_country_title = resp.app_country_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);

                this.Update();
                if (onDone) {
                    onDone();
                }

            }, (err) => {
                this._errDialog.ShowApiError(err);
            });
        }
    }*/
    BrandsPayoutsKeyValsListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandsPayoutsKeyValsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandAppPayoutKeyVal.exec({
                data: {
                    brand_app_payout_id_keyval_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandsPayoutsKeyValsListCtl;
}(BaseController_1.BaseController));
exports.BrandsPayoutsKeyValsListCtl = BrandsPayoutsKeyValsListCtl;
/*export interface IEditAppCountryItem {

    key: number;
    app_country_id: number;

}*/ 



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsPayoutsKeyValsListCtl.ts
// module id = 1049
// module chunks = 0